import { lifeActionTypes } from 'src/actions/actionTypes'

const initialState = {
  userDetails: {
    gender: '',
    fullName: '',
    mobileNumber: '',
    dateOfBirth: '',
    insuredMembers: [],
  },
  ageDetails: {},
  selectedQuickQuote: null,
  proposerDetails: {},
  insuredMembers: [],
  nomineeDetails: {},
}

const buyPolicyLifeReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case lifeActionTypes.UPDATE_LIFE_USER_DETAILS:
      return { ...state, userDetails: action.payload }
    case lifeActionTypes.UPDATE_LIFE_MEMBER_AGE_DETAILS:
      return { ...state, ageDetails: action.payload }
    case lifeActionTypes.UPDATE_LIFE_SELECTED_QUICK_QUOTE:
      return { ...state, selectedQuickQuote: action.payload }
    case lifeActionTypes.UPDATE_LIFE_INSURED_MEMBER_DETAILS:
      return { ...state, insuredMembers: action.payload }
    case lifeActionTypes.UPDATE_LIFE_NOMINEE_DETAILS:
      return { ...state, nomineeDetails: action.payload }
    case lifeActionTypes.UPDATE_LIFE_PROPOSER_DETAILS:
      return { ...state, proposerDetails: action.payload }
    default:
      return state
  }
}

export default buyPolicyLifeReducer
